'use no memo';
import type {ReactElement} from 'react';
import React from 'react';
import {useGetSlideShowItemWithSelectedImageSlide} from '@Hooks/poster-editor/useGetSlideShowItemWithSelectedImageSlide';
import {BaseImageMediaControls} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-image-media-controls';
import type {ItemData} from '@PosterWhiteboard/page/add-item.class';
import {onReplaceMediaSlide} from '@PosterWhiteboard/page/replace-item.class';
import {noop} from '@Utils/general.util';
import {RemoveBackgroundStatus} from '@PosterWhiteboard/items/item/item.types';
import {useGetKeyFromSelectedImageSlide} from '@Hooks/poster-editor/useGetKeyFromSelectedImageSlide';

export function ImageSlideMediaControls(): ReactElement<any> {
  const {activeSlide} = useGetSlideShowItemWithSelectedImageSlide();
  const removeBackground = useGetKeyFromSelectedImageSlide('removeBackground');
  const removeBackgroundStatus = removeBackground?.isBackgroundBeingRemoved
    ? RemoveBackgroundStatus.REMOVING
    : removeBackground?.isBackgroundRemoved
      ? RemoveBackgroundStatus.REMOVED
      : RemoveBackgroundStatus.NONE;

  const replaceImageSlide = (itemToReplaceWith: ItemData): void => {
    onReplaceMediaSlide(itemToReplaceWith);
  };

  return <BaseImageMediaControls activeItem={activeSlide} removeBackgroundStatus={removeBackgroundStatus} onReplaceImage={replaceImageSlide} onClickAiEdit={noop} />;
}
